/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-use-before-define */
import React from 'react';
import { useParams, useLoaderData } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import CreateForm from '../../Forms/CreateForm';
import SelectItemType from '../../ProductsAndServices/SelectItemType';
import ExtraFields from '../../ProductsAndServices/ExtraFields';
import ActionErrorInformation from '../../../API/ActionErrorInformation';
import FormSubmitPortal from '../../Forms/builders/FormSubmitPortal';
import IconButton from '../../UI/IconButton/IconButton.tsx';
import { Carat } from '../../UI/Icons/Icons';
import useProductFields from '../../ProductsAndServices/ProductFields/productFields';

function ProductForm() {
  const { products } = useLoaderData();
  const { productId } = useParams();

  // Form fields definition
  const {
    submitting,
    fields,
    formik,
    itemType,
    setItemType,
    setValue,
    profitType,
  } = useProductFields({
    productId,
    products,
  });

  return !itemType ? (
    <SelectItemType setValue={setValue} setItemType={setItemType} narrow />
  ) : (
    <>
      <ActionErrorInformation />
      <Form
        className="mt-2 flex__form-wrapper px-2 p-md-0"
        noValidate
        onSubmit={formik.handleSubmit}
        id="ob-new-prod-or-serv"
      >
        <CreateForm structure={[fields[0]]} {...formik} />
        <ExtraFields
          structure={fields[1]}
          {...formik}
          profitType={profitType}
          narrow
        />

        <FormSubmitPortal portalId="ob-prod-or-service-submit">
          <div className="d-flex align-items-center gap-3">
            <IconButton
              text="Next"
              type="submit"
              form="ob-new-prod-or-serv"
              alignText="left"
              color="primary"
              outline={false}
              disabled={submitting || (!formik.isValid && !formik.dirty)}
            >
              <Carat />
            </IconButton>
          </div>
        </FormSubmitPortal>
      </Form>
    </>
  );
}

export default ProductForm;
